import { Grid } from '@mui/material';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { gridSizeMdLg12, useTableFilter, useTableServerSideFiltering } from '@/shared';
import { useFetchUbicacionProducto, useGetFlotaByUser } from '../actions/noc-module.actions';
import { toast } from 'react-toastify';
import { GeneralTable } from '@/shared/components/ui';
import { useTableColumnsUbicacionProducto } from '../hooks/useTableColumnsUbicacionProducto';
import AddIcon from '@mui/icons-material/AddCircle';

export type AddEquipamentsModalProps = {
    open: boolean;
    setOpen: (open: boolean) => void;
    idActivitiesOrder: any;
    form: any;
};

const AddEquipamentsModal: React.FC<AddEquipamentsModalProps> = ({
    open,
    setOpen,
    idActivitiesOrder,
    form
}) => {
    const username = JSON.parse(localStorage.getItem("auth") || "{}")?.state?.user?.username;

    const { pagination, setPagination } = useTableFilter();
    const { pageIndex, pageSize } = pagination;
    const { filterObject, columnFilters, setColumnFilters } = useTableServerSideFiltering();
    const { columnsUbicacionProducto } = useTableColumnsUbicacionProducto();

    const { data: flotaUserRes } = useGetFlotaByUser(username) as any;
    const codigoUbicacion = flotaUserRes?.data;

    const {
        isLoading,
        data: ubicacionProductoRes,
        isRefetching
    } = useFetchUbicacionProducto({
        page: pageIndex + 1,
        page_size: pageSize,
        estado: true,
        ...(codigoUbicacion?.data.length > 0 && { ubicacion: codigoUbicacion?.data?.[0]?.ubicacion_data?.codigo }),
        ...filterObject,
    }, {
        enabled: !!codigoUbicacion,
    });

    const handleClose = () => {
        setOpen(false);
    };

    const onAdd = (original: any) => {

        const activities = form.getValues("activitiesOrder") || [];
        const index = activities.findIndex(
            (a: any) => a.idActivitiesOrder === idActivitiesOrder
        );

        if (index === -1) return;

        const currentActivities = activities[index] || [];
        const currentEquipment = activities[index].equipmentUsed || [];

        if (currentActivities.forTheActivity === "CLIENTE" && currentActivities.clientStoreCode === '') {
            toast.error("El Cliente Asignado no cuenta con la ubicacion de productos.");
            return false;
        }
        if (currentActivities.forTheActivity === "NODO" && currentActivities.nodeLocationCode === '') {
            toast.error("El Nodo Asignado no cuenta con la ubicacion de productos.");
            return false;
        }

        if (original.cantidad <= 0) {
            toast.error("No hay stock suficiente para el producto");
            return false;
        }

        const equipmentUsed = {
            idEquipmentUsed: '',
            codeProductUsed: original.producto,
            nameProductUsed: original.producto_data.descripcion,
            descriptionEquipmentUsed: '',
            amountProductUsed: 1,
            statusProductUsed: 'INSTALADO',
            requiresSeries: original.producto_data.contiene_serie,
            usaMeters: original.producto_data.usa_metros,
            originStoreCode: original.bodega_data.codigo,
            originLocationCode: original.ubicacion_data.codigo,
            destinationStoreCode: currentActivities.forTheActivity === "CLIENTE" ? currentActivities.clientStoreCode : currentActivities.nodeStoreCode,
            destinationLocationCode: currentActivities.forTheActivity === "CLIENTE" ? currentActivities.clientLocationCode : currentActivities.nodeLocationCode,
            series_data: original.series_data || [],
        };

        form.setValue(`activitiesOrder.${index}.equipmentUsed`, [
            ...currentEquipment,
            equipmentUsed
        ]);

        toast.success("Equipamiento agregado correctamente");
    };

    return (
        <>
            <ScrollableDialogProps
                open={open}
                title={"Agregar Equipamiento"}
                width="100%"
                contentNode={
                    <>
                        <Grid container spacing={3}>
                            <Grid item {...gridSizeMdLg12}>
                                <GeneralTable<any>
                                    columns={columnsUbicacionProducto}
                                    data={ubicacionProductoRes?.data?.data || []}

                                    isLoading={isLoading}
                                    isRefetching={isRefetching}
                                    // // search
                                    enableGlobalFilter={false}
                                    // onGlobalFilterChange={setGlobalFilter}
                                    // // pagination
                                    pagination={pagination}
                                    onPaging={setPagination}
                                    rowCount={ubicacionProductoRes?.data?.count || 0}

                                    ///* filters - server side
                                    enableManualFiltering={true}
                                    columnFilters={columnFilters}
                                    onColumnFiltersChange={setColumnFilters}
                                    enableSorting={false}

                                    enableColumnActions={true}
                                    positionActionsColumn='first'

                                    // // actions
                                    actionsColumnSize={120}
                                    // crud
                                    enableEditing={true}
                                    onEdit={onAdd}
                                    editIcon={<AddIcon />}
                                    toolTipTitleEditIcon={"Agregar"}

                                    canDelete={false}
                                />
                            </Grid>
                        </Grid>
                    </>
                }
                onClose={handleClose}
            />
        </>
    );
}

export default AddEquipamentsModal;